import { useEffect, type ReactNode } from 'react';
import { useAuth } from '@clerk/clerk-react';

import { applyIdentity, initTelemetry } from './client';

type TelemetryProviderProps = {
  children: ReactNode;
};

// Must render inside `ClerkProvider` — it reads `useAuth` to sync identity.
export function TelemetryProvider({ children }: TelemetryProviderProps) {
  const { isSignedIn, userId } = useAuth();

  useEffect(() => {
    initTelemetry();
  }, []);

  useEffect(() => {
    applyIdentity({ isSignedIn, userId });
  }, [isSignedIn, userId]);

  return <>{children}</>;
}
